// extracted by mini-css-extract-plugin
export default {"footer_container":"footer_footer_container__XsTo8","wrap":"footer_wrap__zexgh"};